import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UxService } from '~/app/core/services';
import { RoleService } from '../../core/services';
import { User } from '../models/user.model';
import { WelcomeApi } from './welcome-api.base';

@Injectable()
export class UsersService extends WelcomeApi<User> {

  constructor(
    http: HttpClient,
    roleService: RoleService,
    uxService: UxService) {
    super('v1/users', http, roleService, uxService);
  }
}
